import Page from '../../classes/Page'
import Hero from '../../modules/Hero'
import { app } from '../../utils/store'
import each from 'lodash/each'

export default class TaxonomyRoomCucina extends Page{
    constructor(){
        super({
            id : 'taxonomy_room_cucina',
            element: '[data-app-page]',
            elements: { 
                hero : document.querySelectorAll('[data-carousel="hero"]'),
                btn_inspiration : document.querySelectorAll('[data-cover-1]'),
                btn_kinds : document.querySelectorAll('[data-kind]'),
                slider_kinds : document.querySelectorAll('[data-child]'),
                btn_kind_2 : document.querySelectorAll('.kind .btn-kind'),
            }
        })
    }

    create() {
        super.create()
        if (this.elements.hero) {
            this.createHero();
        }
        if (this.elements.btn_inspiration){
            this.changeImage();
        }
        if (this.elements.btn_kinds) {
            this.changeSlide();
        }
        if (this.elements.btn_kind_2) {
            this.changeImageKind();
        }

    }

    createHero() {
        each(this.elements.hero, (entry) => { return new Hero({ element: entry }) })

    }

    changeImage = () => {
        const cover_1 = this.element.querySelector('.cover-1 img');
        const cover_2 = this.element.querySelector('.cover-2 img');
        const cover_3 = this.element.querySelector('.cover-3 img');
        each(this.elements.btn_inspiration, (btn) => {
            btn.onmouseover = (event) => {
                let data_cover_1 = event.target.getAttribute('data-cover-1');
                let data_cover_2 = event.target.getAttribute('data-cover-2');
                let data_cover_3 = event.target.getAttribute('data-cover-3');

                if (data_cover_1 != cover_1.getAttribute('src')) {
                    cover_1.style.setProperty('opacity', '0');
                    cover_2.style.setProperty('opacity', '0');
                    cover_3.style.setProperty('opacity', '0');
                    setTimeout(() => {
                        cover_1.setAttribute('src', data_cover_1);
                        cover_2.setAttribute('src', data_cover_2);
                        cover_3.setAttribute('src', data_cover_3);
                        cover_1.style.setProperty('opacity', '1');
                        cover_2.style.setProperty('opacity', '1');
                        cover_3.style.setProperty('opacity', '1');
                    }, 200);
                }
            };
        })
    }

    changeImageKind = () => {
        const image_bg = this.element.querySelector('.image-bg');
        each(this.elements.btn_kind_2, (btn) => {
            btn.onmouseover = (event) => {
                let data_image_bg = event.target.getAttribute('data-image-bg');

                if (data_image_bg != image_bg.getAttribute('src')) {
                    image_bg.style.setProperty('opacity', '0');
                    setTimeout(() => {
                        image_bg.setAttribute('src', data_image_bg);
                        image_bg.style.setProperty('opacity', '1');
                    }, 200);
                }
            };
        })
    }

    changeSlide = () => {
        each(this.elements.btn_kinds, (btn) => {
            btn.onclick = (event) =>{
                event.preventDefault();
                let data_kind = event.target.getAttribute('data-kind');
                each(this.elements.slider_kinds, (slide) => {
                    slide.style.setProperty('display', 'none');
                    if  (slide.getAttribute('data-child') == data_kind) {
                        slide.style.setProperty('display', 'flex');
                    }
                })
            }
        });
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}